import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  // Auth endpoints that should handle their own errors (not redirect)
  private readonly authEndpoints = ['/auth/login.php', '/auth/register.php'];

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Skip redirect for auth endpoints - let the login/register component handle errors
        const isAuthEndpoint = this.authEndpoints.some(endpoint => req.url.includes(endpoint));

        if (!isAuthEndpoint && (error.status === 401 || error.error?.logout)) {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('userData');
          window.location.href = '/login';
        }
        return throwError(() => error);
      })
    );
  }
}